import { useEffect, useState } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import useAuth from 'hooks/useAuth'
import { MaterialReceiptStation } from 'types/materialReceipt.interface'

// Role gating — "reuse an existing permission" (per product decision):
// access is granted by the existing `operations` module flag (material receipt is an operational
// intake process) or admin/company-admin; Manager vs Lab is decided by the role name. No new
// permission-policy fields are introduced. Change ACCESS_FLAG if a different module flag is preferred.
const ACCESS_FLAG = 'operations'

export const useMaterialReceiptStation = (): MaterialReceiptStation | null => {
  const { user, isAdmin } = useAuth()
  const [companyAdmin, setCompanyAdmin] = useState(false)

  useEffect(() => {
    let mounted = true
    fetchAuthSession()
      .then((session) => {
        const groups = session.tokens?.idToken?.payload['cognito:groups'] as string[] | undefined
        if (mounted && groups?.includes('company_administrator')) setCompanyAdmin(true)
      })
      .catch(() => undefined)
    return () => {
      mounted = false
    }
  }, [])

  const policy = user?.currentContract?.role?.permissionPolicy as { [k: string]: boolean } | undefined
  const roleName = (user?.currentContract?.role?.name || '').toLowerCase()
  const hasAccess = isAdmin || companyAdmin || Boolean(policy?.[ACCESS_FLAG])

  if (!hasAccess) return null
  if (roleName.includes('lab')) return 'LAB'
  return 'MANAGER'
}
